import { useTranslation } from "react-i18next"
import { DotPill, Tone } from "../../delivery/atoms"

const TONES: Record<string, Tone> = {
  DRAFT: "grey",
  ASSIGNED: "blue",
  LOADED: "amber",
  PENDING_HANDOVER: "amber",
  DELIVERING: "green",
  DELIVERED: "green",
  CANCELLED: "grey",
  RETURNED: "grey",
}

interface Props {
  status: string | null | undefined
  /** Kept for call-site compatibility; the pill has one size. */
  size?: unknown
}

/** DN status as a dot pill; labels = the Идэвхтэй status tabs (one name set, O108). */
export function DnStatusBadge({ status }: Props) {
  const { t } = useTranslation("delivery")
  if (!status) return <>-</>
  return <DotPill tone={TONES[status] ?? "grey"}>{t(`badges.dnStatus.${status}`, { defaultValue: "-" })}</DotPill>
}
